// Static city catalogue used for /shipping-to/:slug pages.
// Mirrors the backend /api/cities response and adds copy + SEO data.
export const CITIES = [
  {
    slug: "san-jose",
    name: "San José",
    region: "San José Province",
    lat: 9.9281,
    lng: -84.0907,
    intro: {
      en: "Door-to-door shipping from Miami to San José. Whether you're in Escazú, Sabana, Curridabat or downtown — we deliver right to your address in 5–7 days for $15/kg.",
      es: "Envíos puerta a puerta desde Miami a San José. Estés en Escazú, Sabana, Curridabat o el centro — entregamos en tu dirección en 5–7 días por $15/kg.",
    },
    bullet: {
      en: "Same-day capital metro delivery options available",
      es: "Opciones de entrega en el día disponibles para el área metropolitana",
    },
  },
  {
    slug: "heredia",
    name: "Heredia",
    region: "Heredia Province",
    lat: 9.9981,
    lng: -84.1167,
    intro: {
      en: "Reliable air shipping from the U.S. to Heredia. We bring your Amazon, eBay, SHEIN and Walmart packages from our Miami warehouse straight to your door.",
      es: "Envío aéreo confiable desde EE.UU. a Heredia. Llevamos tus paquetes de Amazon, eBay, SHEIN y Walmart desde nuestra bodega en Miami hasta tu puerta.",
    },
    bullet: {
      en: "Trusted route for tech & university shoppers in Heredia",
      es: "Ruta confiable para compradores de tecnología y universitarios en Heredia",
    },
  },
  {
    slug: "alajuela",
    name: "Alajuela",
    region: "Alajuela Province",
    lat: 10.0162,
    lng: -84.2117,
    intro: {
      en: "Air freight from Miami to Alajuela — the airport hub gets the fastest connection. Door delivery in 5–7 days at $15/kg.",
      es: "Carga aérea desde Miami a Alajuela — la zona del aeropuerto recibe la conexión más rápida. Entrega a domicilio en 5–7 días a $15/kg.",
    },
    bullet: { en: "Fast access from SJO airport zone", es: "Acceso rápido desde la zona del aeropuerto SJO" },
  },
  {
    slug: "cartago",
    name: "Cartago",
    region: "Cartago Province",
    lat: 9.8638,
    lng: -83.9197,
    intro: {
      en: "Trusted U.S.-to-Costa-Rica shipping to Cartago. We forward your boxes from Miami straight to your home or business.",
      es: "Envío confiable desde EE.UU. a Cartago. Reenviamos tus cajas desde Miami directamente a tu casa o negocio.",
    },
    bullet: { en: "Door delivery across the historic colonial capital", es: "Entrega a domicilio en toda la antigua capital colonial" },
  },
  {
    slug: "liberia",
    name: "Liberia",
    region: "Guanacaste",
    lat: 10.6346,
    lng: -85.4377,
    intro: {
      en: "Shipping to Liberia, Guanacaste — we deliver your U.S. packages right to your door. Perfect for residents, expats and businesses across the region.",
      es: "Envíos a Liberia, Guanacaste — entregamos tus paquetes de EE.UU. en tu puerta. Ideal para residentes, expatriados y negocios de la región.",
    },
    bullet: { en: "Hub for the entire Guanacaste province", es: "Centro para toda la provincia de Guanacaste" },
  },
  {
    slug: "tamarindo",
    name: "Tamarindo",
    region: "Guanacaste",
    lat: 10.2993,
    lng: -85.8407,
    intro: {
      en: "Tamarindo's go-to Miami → Costa Rica shipping service. Surf gear, Amazon orders, electronics — delivered to your beach door for $15/kg.",
      es: "El servicio favorito de Tamarindo de Miami a Costa Rica. Equipo de surf, pedidos de Amazon, electrónicos — entregados en tu puerta frente al mar a $15/kg.",
    },
    bullet: { en: "Trusted by expats, surfers and beach-town businesses", es: "Confiado por expatriados, surfistas y negocios de la zona costera" },
  },
  {
    slug: "jaco",
    name: "Playa Jacó",
    region: "Puntarenas",
    lat: 9.6147,
    lng: -84.6285,
    intro: {
      en: "Shipping to Playa Jacó made easy. Order from Amazon, eBay, SHEIN or any U.S. store and we'll deliver to your Jacó address in 5–7 days.",
      es: "Envíos a Playa Jacó fácil y rápido. Compra en Amazon, eBay, SHEIN o cualquier tienda de EE.UU. y entregamos en tu dirección de Jacó en 5–7 días.",
    },
    bullet: { en: "Door delivery from downtown Jacó to Playa Hermosa", es: "Entrega a domicilio desde el centro de Jacó hasta Playa Hermosa" },
  },
  {
    slug: "quepos",
    name: "Quepos / Manuel Antonio",
    region: "Puntarenas",
    lat: 9.4321,
    lng: -84.161,
    intro: {
      en: "Air shipping from Miami to Quepos and Manuel Antonio. Reliable door delivery for residents, lodge owners and businesses on the central Pacific coast.",
      es: "Envío aéreo desde Miami a Quepos y Manuel Antonio. Entrega confiable a domicilio para residentes, dueños de lodges y negocios de la costa Pacífico central.",
    },
    bullet: { en: "Coastal-route delivery for Quepos & Manuel Antonio", es: "Entrega ruta costera para Quepos y Manuel Antonio" },
  },
  {
    slug: "nosara",
    name: "Nosara",
    region: "Guanacaste",
    lat: 9.9781,
    lng: -85.6535,
    intro: {
      en: "Reliable shipping to Nosara, Guanacaste. We get your U.S. packages to this remote surf and yoga town with care and tracking the whole way.",
      es: "Envíos confiables a Nosara, Guanacaste. Llevamos tus paquetes de EE.UU. a este pueblo remoto de surf y yoga con cuidado y seguimiento todo el camino.",
    },
    bullet: { en: "Specialised remote-zone delivery to Nosara", es: "Entrega especializada en zona remota para Nosara" },
  },
  {
    slug: "limon",
    name: "Limón",
    region: "Limón Province",
    lat: 9.9907,
    lng: -83.0359,
    intro: {
      en: "Caribbean coast shipping — Miami to Limón. We bring your boxes to the Caribbean side of Costa Rica with full tracking.",
      es: "Envíos a la costa caribeña — de Miami a Limón. Llevamos tus cajas al lado caribeño de Costa Rica con seguimiento completo.",
    },
    bullet: { en: "Caribbean-coast door delivery", es: "Entrega a domicilio en la costa caribeña" },
  },
  {
    slug: "puntarenas",
    name: "Puntarenas",
    region: "Puntarenas Province",
    lat: 9.9763,
    lng: -84.8389,
    intro: {
      en: "Shipping to Puntarenas — port city on the Pacific. From the city to surrounding beach towns, we deliver to your door.",
      es: "Envíos a Puntarenas — ciudad portuaria del Pacífico. Desde la ciudad hasta los pueblos de playa cercanos, entregamos en tu puerta.",
    },
    bullet: { en: "Pacific-coast city & nearby beach towns", es: "Ciudad de la costa Pacífico y pueblos de playa cercanos" },
  },
  {
    slug: "santa-cruz",
    name: "Santa Cruz",
    region: "Guanacaste",
    lat: 10.2632,
    lng: -85.5853,
    intro: {
      en: "Air shipping to Santa Cruz, Guanacaste. We deliver from Miami to your door — a trusted route for the region's residents and businesses.",
      es: "Envío aéreo a Santa Cruz, Guanacaste. Entregamos desde Miami a tu puerta — una ruta confiable para residentes y negocios de la región.",
    },
    bullet: { en: "Trusted Guanacaste-region delivery", es: "Entrega confiable en la región de Guanacaste" },
  },
];

export const findCity = (slug) => CITIES.find((c) => c.slug === slug);
